const googleSignInSettings = {
	clientId:
		"707837860241-9so4a2vj9lnu3febg06t9miqd12ovjpi.apps.googleusercontent.com",
	workspaceDomain: "myclinicaloutcomes.com"
} as const

export default googleSignInSettings
